import { UNIFORM_STAGES } from "./entities.js";
import { FACTORY_SECTORS, SECTOR_STAGES } from "./sectors.js";
/**
 * A produção por setor (F240) e a baixa do dia (F241).
 *
 * As anotações do dono da 4Play (05/10): "estatística de cada setor
 * (dia/semana/mês)" e "subtração de estoque no final do dia". O que um setor
 * fez é o que SAIU dele para a frente: cada troca de etapa guarda quantas
 * peças andaram (desde a F240), e a peça que sai da impressão para o corte
 * conta para a impressão.
 */
/** Os setores com estatística: o atendimento, a arte e os da fábrica. */
export const STATS_SECTORS = [
    'atendimento',
    'arte',
    ...FACTORY_SECTORS,
];
export const STATS_SECTOR_STAGES = {
    atendimento: ['atendimento'],
    arte: ['arte'],
    ...SECTOR_STAGES,
};
const position = (stage) => UNIFORM_STAGES.indexOf(stage);
/** O setor dono da etapa, ou nulo ("pronto" não é de ninguém). */
export const statsSectorOf = (stage) => STATS_SECTORS.find((sector) => STATS_SECTOR_STAGES[sector].includes(stage)) ??
    null;
/**
 * O setor que TERMINOU com esta troca de etapa: a etapa de onde saiu é dele, e
 * a de destino fica depois de todas as dele. Andar dentro do setor
 * ("iniciar impressão" → "imprimindo"), voltar, ou mudar de leva na mesma
 * etapa não é produção.
 */
export const sectorFinished = (from, to) => {
    const sector = statsSectorOf(from);
    if (sector === null)
        return null;
    const last = Math.max(...STATS_SECTOR_STAGES[sector].map(position));
    return position(to) > last ? sector : null;
};
/** Como a estatística agrupa: por dia, semana (segunda a domingo) ou mês. */
export const STATS_GROUPS = ['day', 'week', 'month'];
/** Até onde cada agrupamento olha — a tela não precisa de mais que isso. */
export const STATS_MAX_DAYS = {
    day: 93,
    week: 371,
    month: 1096,
};
const DAY_MS = 86_400_000;
const asDay = (value) => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value))
        return null;
    const time = Date.parse(`${value}T00:00:00Z`);
    return Number.isNaN(time) ||
        new Date(time).toISOString().slice(0, 10) !== value
        ? null
        : time;
};
/** O período pedido: de ≤ até, as duas datas válidas, sem passar do limite. */
export const checkStatsRange = (from, to, group) => {
    const start = asDay(from);
    const end = asDay(to);
    if (start === null || end === null || start > end)
        return 'range_invalid';
    return (end - start) / DAY_MS + 1 > STATS_MAX_DAYS[group]
        ? 'range_too_long'
        : null;
};
/** O dia seguinte, para o fim do período em "menor que". */
export const nextDay = (day) => new Date(Date.parse(`${day}T00:00:00Z`) + DAY_MS).toISOString().slice(0, 10);
// ---------------------------------------------------------------------------
// A baixa do dia (F241)
// ---------------------------------------------------------------------------
/** Quantos dias para trás a baixa ainda pode ser lançada. */
export const DAY_CLOSE_MAX_AGE_DAYS = 31;
/**
 * A baixa de um dia: não no futuro, não de mais de um mês, pelo menos um
 * material, e cada material uma vez só.
 */
export const checkDayClose = (input) => {
    const day = asDay(input.day);
    const today = asDay(input.today);
    if (day === null || today === null || day > today)
        return 'day_in_future';
    if ((today - day) / DAY_MS > DAY_CLOSE_MAX_AGE_DAYS)
        return 'day_too_old';
    if (input.variantIds.length === 0)
        return 'nothing_to_close';
    if (new Set(input.variantIds).size !== input.variantIds.length) {
        return 'repeated_material';
    }
    return null;
};
//# sourceMappingURL=stats.js.map